import { gql } from "@apollo/client";

const USERPENDINGCHATSDATA = gql`
  query userPendingChatsData($agentId: ID!) {
    userPendingChatsData(agentId: $agentId) {
      success
      error
      result
    }
  }
`;

export default USERPENDINGCHATSDATA;
